import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CommonService } from 'src/app/services/common.service';
import { User } from 'src/app/services/UserManagement';
import { AlertService } from '../ims-alerts/ims-alerts.service';
import { StringUtils } from '../utility/stringUtils';

@Component({
    selector: 'app-app-staff-card',
    templateUrl: './app-staff-card.component.html',
    styleUrls: ['./app-staff-card.component.scss'],
    standalone: false
})
export class AppStaffCardComponent implements OnInit {
	loaded = false;
	user: User;
	name: string;
	phone: string;

	constructor(
		public dialogRef: MatDialogRef<AppStaffCardComponent>,
		@Inject(MAT_DIALOG_DATA) public data,
		private cmnServ: CommonService,
		private alert: AlertService,
		private snackBar: MatSnackBar
	) {}

	ngOnInit(): void {
		this.getUserById(this.data.userDetailId);
	}

	private getUserById(id: string) {
		this.cmnServ.getUserById(id).subscribe(
			(res) => {
				this.loaded = true;
				this.user = res;
				this.getUserName();
				this.getPhone();
			},
			(error) => {
				this.loaded = true;
				this.alert.error('Error happened while getting user info. Please contact help desk.', error);
			}
		);
	}

	private getUserName() {
		this.name = StringUtils.concatName(
			this.user.personName.lastName,
			this.user.personName.middleInitial,
			this.user.personName.firstName,
			this.user.personName.namePrefix,
			this.user.personName.nameSuffix
		);
	}

	private getPhone() {
		if (this.user?.contactInformation) {
			this.phone = this.user.contactInformation.workPhone;
			if (this.phone && this.user.contactInformation.workPhoneExtension) {
				this.phone += ` - ${this.user.contactInformation.workPhoneExtension}`;
			}
		}
	}

	public copyToClipboard(text) {
		var dummy = document.createElement('textarea');
		document.body.appendChild(dummy);
		dummy.value = text;
		dummy.select();
		document.execCommand('copy');
		document.body.removeChild(dummy);
		this.openSnackBar();
	}

	private openSnackBar() {
		this.snackBar.open('Copied!', 'OK', {
			duration: 1000,
		});
	}
}
